import { AccountCircle, Assignment, Cancel, Chat, Close, CloseOutlined, Edit, HighlightOffRounded, PersonOutline } from '@mui/icons-material';
import { Box, Button, Card, Chip, Dialog, DialogContent, Fab, FormControl, Grid, IconButton, MenuItem, Modal, Paper, Rating, Select, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { ProviderServices } from '../../Provider/CrudServices';
import { formatDateTime } from '../../../utils/dateUtils';
import { useForm, Controller } from 'react-hook-form';
import Swal from 'sweetalert2';
import { PermissionGuard } from '../../../components/PermissionGuard';
import { isMobile } from 'react-device-detect';
import ChatBox from './ChatBox';
import PaymentDetails from './PaymentDetails';
import { useNavigate, useParams } from 'react-router-dom';
import { BookingService } from '../Service';
import MainContentLayout from '../../../components/Layout/MainContentLayout';
import { useDispatch } from 'react-redux';
import PageHeaderLayout from '../../../components/Layout/PageHeaderLayout';
import Viewdetails from './Viewdetails';

dayjs.extend(customParseFormat);

const BookingDetails = () => {
    const menuDispatch = useDispatch();
    useEffect(() => {
        menuDispatch({
            type: 'menuSelect',
            payload: 'bookings'
        });
    }, []);
    const { bookingId } = useParams();
    const navigate = useNavigate();
    const [openDiscountModal, setOpenDiscountModal] = useState(false);
    const [bookingStatus, setBookingStatus] = useState('completed');
    const [bookingServiceDate, setBookingServiceDate] = useState(null);
    const [paymentMethod,setPaymentMethod] = useState(null);
    const isServiceDateInPast = (serviceDate) => {
        const today = dayjs().startOf('day');
        const serviceDay = dayjs(serviceDate).startOf('day');
        return serviceDay.isBefore(today);
    }
  return (
    <>
        <PageHeaderLayout headerTitle={`Booking Detail's`} >
            { (bookingStatus == 'requested' || bookingStatus == 'accepted' || bookingStatus == 'ongoing') && bookingServiceDate && paymentMethod=='CASH'&&(
                (!isServiceDateInPast(bookingServiceDate)) ? (
                    <PermissionGuard feature="booking" permission="canEdit" >
                        <Button variant='contained' size='small' color='warning'
                            onClick={()=>navigate(`/admin/booking/modify/${bookingId}`)
                            } 
                            sx={{ textTransform:'capitalize' }}
                            startIcon={<Edit />}
                        >
                            Modify Booking
                        </Button>
                    </PermissionGuard>
                ) : (
                    <PermissionGuard feature="past-booking" permission="canEdit" >
                        <Button variant='contained' size='small' color='warning'
                            onClick={()=>navigate(`/admin/booking/modify/${bookingId}`)
                            } 
                            sx={{ textTransform:'capitalize' }}
                            startIcon={<Edit />}
                        >
                            Modify Booking
                        </Button>
                    </PermissionGuard>
                )
            )}
            <PermissionGuard feature="booking" permission="canCreate" >
                <Button variant='contained' size='small' 
                    onClick={()=>navigate('/admin/booking/new')
                    } 
                    sx={{ textTransform:'capitalize' }}
                >
                    New Booking
                </Button>
            </PermissionGuard>
            <Button variant='contained' size='small' 
                onClick={()=>navigate('/admin/booking')
                } 
                sx={{ display:{xs:'none',sm:'block'},textTransform:'capitalize' }}
            >
                {'See Bookings List'}
            </Button>
        </PageHeaderLayout> 
        {/* <PermissionGuard feature="booking" permission="canCreate" > */}
        <Button variant='contained' size='small' 
                    onClick={()=>navigate('/admin/booking/new')
                    } 
                    sx={{ textTransform:'capitalize' ,display:{xs:'block',sm:'none',width:'100%',marginBottom:'1%'}}}
                >
                    Apply Discount
                </Button>
            {/* </PermissionGuard> */}   
        <Viewdetails bookingId={bookingId} setBookingStatus={setBookingStatus} setBookingServiceDate={setBookingServiceDate} setPaymentMethod={setPaymentMethod}/>
        
    </>
  );
}

export default BookingDetails;
